import React, { Component } from 'react';
import {
  Form,
  Input,
  Label,
  Button
} from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class NervousSystem extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="NervousSystem">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="NervousSystem__Form"
        >
          <h1>{translate('fiche.nervous_system.title')}</h1>
          <Label text={translate('fiche.nervous_system.romberg')} />
          <Input
            name="romberg"
            rules={['required']}
            defaultValue={data.romberg}
          />

          <Label text={translate('fiche.nervous_system.equilibrium_test')} />
          <Input
            name="equilibrium_test"
            rules={['required']}
            defaultValue={data.equilibrium_test}
          />

          <Label text={translate('fiche.nervous_system.coordination_and_motoring')} />
          <Input
            name="coordination_and_motoring"
            rules={['required']}
            defaultValue={data.coordination_and_motoring}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(NervousSystem);
